import { useAIAssistant, useFloatingChat } from '@cobliteam/ai';
import { Location } from '@cobliteam/common-types';
import useBlipChat from '@cobliteam/hooks/src/useBlipChat';
import useChatWidget from '@cobliteam/hooks/src/useChatWidget';
import useFeatureFlags from '@cobliteam/hooks/src/useFeatureFlags';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const ChatWidget = () => {
  const { setPosition, hide } = useChatWidget();
  const { aiRecommendations } = useFeatureFlags();
  const history = useHistory();
  const { isAISidepanelOpen } = useAIAssistant();
  const setBlipChatOpen = useFloatingChat((s) => s.setBlipChatOpen);
  const { build: blipChatBuild } = useBlipChat({
    onClose: () => {
      hide(false);
      setBlipChatOpen(false);
    },
  });

  useEffect(() => {
    blipChatBuild();
  }, [blipChatBuild]);

  useEffect(() => {
    // When aiRecommendations is on, FloatingChatButton mounts and owns hide(true).
    // ChatWidget must not interfere to avoid conflicting hide/show calls.
    if (aiRecommendations) return;

    const hasDefaultTab = history.location.pathname === Location.MONITORING || history.location.pathname === Location.TRACKING;
    const blipContainer = document.getElementById('blip-chat-container');

    if (isAISidepanelOpen) {
      if (blipContainer) blipContainer.style.setProperty('display', 'none', 'important');
      hide(true);
    } else {
      if (blipContainer) blipContainer.style.removeProperty('display');
      hide(false);
      setPosition(hasDefaultTab ? 'tab' : 'default');
    }
  }, [history.location.pathname, setPosition, hide, isAISidepanelOpen, aiRecommendations]);

  return null;
};

export default ChatWidget;
